import { shouldPreventScrollToTop } from '@/js/quests/game/helpers/scrollHelper';

function scrollToHashWithTimeout(hash: string, timeout = 500): void {
    const element: HTMLElement = document.querySelector(hash);

    if (element instanceof HTMLElement) {
        const startTime = performance.now();
        const waitAndScroll = (timestamp: number) => {
            if (timestamp - startTime >= timeout) {
                element.scrollIntoView({ behavior: 'smooth' });
            } else {
                requestAnimationFrame(waitAndScroll);
            }
        };

        requestAnimationFrame(waitAndScroll);
    }
}

window.addEventListener('load', () => {
    // If game is active, the router's scrollBehavior handles hash scrolling
    // Skip this to avoid conflicts
    if (shouldPreventScrollToTop()) {
        return;
    }

    const hash = window.location.hash;

    if (hash) {
        scrollToHashWithTimeout(hash);
    }
});
